import { QueryClient } from '@tanstack/react-query'

/**
 * React Query client with default configuration.
 * CMS data is cached for 5 minutes to reduce API load.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
})
